var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMna0Yq0FJzsnn6W(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0248 15.6829C11.8664 15.6829 11.7081 15.6246 11.5831 15.4996C11.3414 15.2579 11.3414 14.8579 11.5831 14.6163L16.1998 9.99961L11.5831 5.38294C11.3414 5.14128 11.3414 4.74128 11.5831 4.49961C11.8248 4.25794 12.2248 4.25794 12.4664 4.49961L17.5248 9.55794C17.7664 9.79961 17.7664 10.1996 17.5248 10.4413L12.4664 15.4996C12.3414 15.6246 12.1831 15.6829 12.0248 15.6829Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9415 10.625L2.91651 10.625C2.57484 10.625 2.29151 10.3417 2.29151 10C2.29151 9.65833 2.57484 9.375 2.91651 9.375L16.9415 9.375C17.2832 9.375 17.5665 9.65834 17.5665 10C17.5665 10.3417 17.2832 10.625 16.9415 10.625Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMna0Yq0FJzsnn6W);
export default __webpack_public_path__ + "static/media/mna0yq0f-jzsnn6w.1d2aac326383062c466a1a7704a838c9.svg";
export { ForwardRef as ReactComponent };